import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [form, setForm]     = useState({ tenant:'', username:'', password:'' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const { login }   = useAuth();
  const navigate    = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const u = await login(form.username, form.password, form.tenant);
      // i tecnici non hanno la dashboard: atterrano sugli interventi
      const ruolo = (u?.ruolo || '').toLowerCase();
      navigate(['admin','segreteria'].includes(ruolo) ? '/' : '/interventi');
    } catch(err) {
      setError(err.response?.data?.error || 'Credenziali non valide.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <img src="/quindi-logo.png" alt="Quindi"
            style={{ width:'100%', maxWidth:220, marginBottom:8 }} />
          <p style={{ color:'#9ca3af', fontSize:13 }}>
            Gestionale antincendio
          </p>
        </div>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Azienda</label>
            <input className="form-control" type="text" placeholder="es. sosfire"
              value={form.tenant}
              onChange={e => setForm(f => ({ ...f, tenant: e.target.value }))}
              required />
          </div>
          <div className="form-group">
            <label className="form-label">Username</label>
            <input className="form-control" type="text" placeholder="admin"
              value={form.username}
              onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
              required />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-control" type="password" placeholder="••••••••"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              required />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}
            style={{ width:'100%', justifyContent:'center', padding:'12px', fontSize:'15px' }}>
            {loading ? '...' : '🔐 Accedi'}
          </button>
        </form>

        <div style={{ textAlign:'center', marginTop:24, padding:'16px', background:'#f9fafb', borderRadius:8, border:'1px solid #e5e7eb' }}>
          <div style={{ fontSize:11, color:'#9ca3af', marginBottom:8, fontWeight:600, letterSpacing:1 }}>CONTATTI E ASSISTENZA</div>
          <div style={{ display:'flex', flexDirection:'column', gap:6, fontSize:12 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
              <span>📧</span>
              <a href="mailto:info@quindi.cloud" style={{ color:'#b30000', textDecoration:'none', fontWeight:500 }}>info@quindi.cloud</a>
              <span style={{ color:'#d1d5db' }}>—</span>
              <span style={{ color:'#6b7280' }}>Nuovi clienti</span>
            </div>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
              <span>🔧</span>
              <a href="mailto:assistenza@quindi.cloud" style={{ color:'#b30000', textDecoration:'none', fontWeight:500 }}>assistenza@quindi.cloud</a>
              <span style={{ color:'#d1d5db' }}>—</span>
              <span style={{ color:'#6b7280' }}>Supporto tecnico</span>
            </div>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
              <span>📞</span>
              <a href="tel:+393272510810" style={{ color:'#b30000', textDecoration:'none', fontWeight:500 }}>327 251 0810</a>
            </div>
            <div style={{ marginTop:4, fontSize:11, color:'#9ca3af' }}>
              Partita IVA: 18647121005
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
